import React, { useEffect, useState } from "react";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import createInstance from "../../../api/axiosinstance";

function ActivationPage() {
  const [isActive, setIsActive] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const aiDishaApi = createInstance("DISHA");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const emailParam = searchParams.get("email");
    const roleParam = searchParams.get("role");

    if (!emailParam) {
      setError("Invalid activation link: Email is missing");
      return;
    }

    setEmail(emailParam);
    setRole(roleParam || ""); // Role might be optional
  }, [location.search]);

  const handleActive = async () => {
    try {
      let apiUrl = "";
      
      // Determine which API to use based on role
      switch (role.toLowerCase()) {
        case "admin":
          apiUrl = `/admin-user-Activation/?email=${encodeURIComponent(email)}`;
          break;
        case "orgadmin":
        case "hr":
        case "managerial":
        case "interviewer":
          apiUrl = `/org-user-activation/?email=${encodeURIComponent(email)}`;
          break;
        default:
          throw new Error("Invalid or missing role in activation link");
      }

      // Using axios properly through the instance
      const response = await aiDishaApi.post(apiUrl, {}, {
        headers: {
          "Content-Type": "application/json",
        }
      });

      console.log("active btn", response);
      setIsActive(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed to activate account. Please try again.");
    }
  };

  if (error) {
    return (
      <div className="container">
        <h1>Activation Error</h1>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>Welcome to STRATEGIC HIRE</h1>
      <p className="message">
        Hello there! This page is used to activate your STRATEGIC HIRE account.
        Please click the button below to get started.
      </p>
      {isActive ? (
        <p>Account activated! Redirecting to login...</p>
      ) : (
        <button className="activation-button" onClick={handleActive}>
          Activate Account
        </button>
      )}
    </div>
  );
}

export default ActivationPage;